<template>
  <transition>
    <div id="character-menu" class="drawer drawer-right drawer-dock-1024" v-show="showCharacterMenu">
      <div class="overlay overlay-drawer" @click="showCharacterMenu=false"></div>

      <div class="drawer-header">
        <span>Karakterek</span>
        <button class="icon-button" @click="showCharacterMenu=false">
          <i class="material-icons" title="Bezárás">close</i>
        </button>
      </div>
      <div class="drawer-body">
        <button :class="['drawer-item', {'drawer-item-selected': currentVoice.type==='narrator'}]"
                @click="selectCharacter('narrator')">
          <i class="material-icons">local_library</i>
          <span>Narrátor</span>
        </button>
        <button :class="['drawer-item', {'drawer-item-selected': currentVoice.type==='ooc'}]"
                @click="selectCharacter('ooc')">
          <i class="material-icons">chat</i>
          <span>Játékon kívüli komment</span>
        </button>
        <div class="drawer-divider"></div>
        <button class="drawer-item" @click="$refs.charaDialog.open(null)">
          <i class="material-icons">person_add</i>
          <span>Új Karakter...</span>
        </button>
        <div class="drawer-divider"></div>
        <template v-for="chara of charas">
          <div :class="['drawer-item', {'drawer-item-selected': currentVoice.charaId===chara._id}]"
               @click="selectCharacter('chara', chara._id)" :key="chara._id">
            <i v-if="chara.avatar" class="material-icons chara-icon-shadow" :style="{'color':chara.color}"
               title="Avatár megnyitása" @click.middle="openLinkSeparately(chara.avatar)"
               @click.prevent.stop="openLinkSeparately(chara.avatar)">account_box</i>
            <i v-else class="material-icons chara-icon-shadow" :style="{'color':chara.color}">person</i>
            <span>{{ chara.name }}</span>

            <button v-if="chara.url" class="icon-button" @click.prevent.stop="openLink(chara.url)"
                    @click.middle="openLinkSeparately(chara.url)">
              <i class="material-icons" title="Megnyitás">link</i>
            </button>
            <button class="icon-button" @click.prevent.stop="$refs.charaDialog.open(chara)">
              <i class="material-icons" title="Szerkesztés">edit</i>
            </button>
          </div>
        </template>
        <div class="drawer-divider"></div>
        <div class='drawer-item'>
          <span>Inaktívak</span>
          <button class="icon-button" @click.prevent.stop="changeShowHiddenCharacters(showHiddenCharacters)">
            <i v-if="!showHiddenCharacters" class="material-icons" title="Mutasd">visibility</i>
            <i v-else class="material-icons" title="Rejtsd">visibility_off</i>
          </button>
        </div>
        <div class="drawer-divider"></div>
        <div v-if='showHiddenCharacters'>
          <template v-for="chara of inactiveCharas">
            <div :class="['drawer-item', {'drawer-item-selected': currentVoice.charaId===chara._id}]"
                 @click="selectCharacter('chara', chara._id)" :key="chara._id">
              <i v-if="chara.avatar" class="material-icons chara-icon-shadow" :style="{'color':chara.color}"
                 title="Avatár megnyitása" @click.middle="openLinkSeparately(chara.avatar)"
                 @click.prevent.stop="openLinkSeparately(chara.avatar)">account_box</i>
              <i v-else class="material-icons chara-icon-shadow" :style="{'color':chara.color}">person</i>
              <span><i>{{ chara.name }}</i></span>
              <button v-if="chara.url" class="icon-button" @click.prevent.stop="openLink(chara.url)"
                      @click.middle="openLinkSeparately(chara.url)">
                <i class="material-icons" title="Megnyitás">link</i>
              </button>
              <button class="icon-button" @click.prevent.stop="$refs.charaDialog.open(chara)">
                <i class="material-icons" title="Szerkesztés">edit</i>
              </button>
            </div>
          </template>
        </div>
      </div>

      <chara-dialog ref="charaDialog"
                    :send="send"
                    @created="selectCharacter('chara', $event._id)"
      ></chara-dialog>
    </div>
  </transition>
</template>

<script>
import CharaDialog from './chara-dialog.vue';
import {openLink, openLinkSeparately} from "../utils/utils";

export default {
  components: {
    CharaDialog
  },
  props: [
    'charas',
    'inactiveCharas',
    'currentVoice',
    'send'
  ],
  data() {
    return {
      showCharacterMenu: false,
      showHiddenCharacters: false
    };
  },
  methods: {
    openLink,
    openLinkSeparately,
    open() {
      this.showCharacterMenu = true;
    },
    selectCharacter(type, charaId) {
      this.$emit('select-voice', {type: type, charaId: charaId || null});
      if (window.matchMedia("(max-width: 1023px)").matches) {
        this.showCharacterMenu = false;
      }
    },
    changeShowHiddenCharacters(value) {
      this.showHiddenCharacters = !value;
    }
  }
};
</script>
